// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.convert.RentalManagerUserPropertyConvertV2WebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  UserPropertyConvertMultiToSingleFamilyRequestDto,
  UserPropertyConvertMultiToSingleFamilyV2ResponseWebDto,
  UserPropertyConvertSingleFamilyToRoomForRentRequestDto,
  UserPropertyConvertSingleFamilyToRoomForRentV2ResponseWebDto,
} from '../..';

export const RentalManagerUserPropertyConvertV2WebApiHandler_multiToSingleFamily_Path =
  '/api/web/v2/users/properties/convert/multiToSingleFamily';

/**
 * Convert a multifamily property to a single family property
 */
export const RentalManagerUserPropertyConvertV2WebApiHandler_multiToSingleFamily = (
  postData: UserPropertyConvertMultiToSingleFamilyRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    UserPropertyConvertMultiToSingleFamilyRequestDto,
    UserPropertyConvertMultiToSingleFamilyV2ResponseWebDto
  >(
    {
      endpoint: RentalManagerUserPropertyConvertV2WebApiHandler_multiToSingleFamily_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyConvertV2WebApiHandler_singleFamilyToRoomForRent_Path =
  '/api/web/v2/users/properties/convert/singleFamilyToRoomForRent';

/**
 * Convert a single family property to a room for rent property
 */
export const RentalManagerUserPropertyConvertV2WebApiHandler_singleFamilyToRoomForRent = (
  postData: UserPropertyConvertSingleFamilyToRoomForRentRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    UserPropertyConvertSingleFamilyToRoomForRentRequestDto,
    UserPropertyConvertSingleFamilyToRoomForRentV2ResponseWebDto
  >(
    {
      endpoint: RentalManagerUserPropertyConvertV2WebApiHandler_singleFamilyToRoomForRent_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
